import Icon from '@mdi/react';
import './icon-button.component.scss';
import { MouseEvent } from 'react';

type IconButtonProps = {
    className?: string;
    onClick?: (e: MouseEvent) => void;
    icon: string;
    title: string;
    role?: string;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
};

const IconButton = ({ className, icon, ...props }: IconButtonProps) => (
    <button className={`icon-btn ${className || ''}`} {...props}>
        <Icon path={icon} size={1} />
    </button>
);

export default IconButton;
